import { useEffect } from 'react';

const RedirectPage = () => {
  useEffect(() => {
    window.location.replace(process.env.REACT_APP_NOMIX_AUTH_URL);
  }, []);
  return null;
};

export default RedirectPage;
